import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

export const organizationFirm = createCrudVuexModule({
  namespaced: true,
  path: "/firm",
  persistent: ["selectedEntity"],
  options: {
    localizedFields: ["name", "description", "vkn", "unitAdminName"],
  },
  state: { summaryPagination: undefined, isSummaryLoading: false, isDownloading: false, firmWithQuestionStatPagination: undefined, firmWithQuestionStatLoading: false },
  getters: {
    summaryPagination: (state) => state.summaryPagination,
    isSummaryLoading: (state) => state.isSummaryLoading,
    isDownloading: (state) => state.isDownloading,
    firmWithQuestionStatPagination: (state) => state.firmWithQuestionStatPagination,
    firmWithQuestionStatLoading: (state) => state.firmWithQuestionStatLoading,
  },
  mutations: {
    summaryPagination: (state, value) => (state.summaryPagination = value),
    isSummaryLoading: (state, value) => (state.isSummaryLoading = value),
    isDownloading: (state, value) => (state.isDownloading = value),
    firmWithQuestionStatPagination: (state, value) => (state.firmWithQuestionStatPagination = value),
    firmWithQuestionStatLoading: (state, value) => (state.firmWithQuestionStatLoading = value),
  },
  actions: {
    async fetchSummary({ commit }, pagination) {
      commit("isSummaryLoading", true);
      try {
        const response = await rest.post("/firm/paginate-detailed", { pagination });
        commit("summaryPagination", response.data);
        return response;
      } finally {
        commit("isSummaryLoading", false);
      }
    },
    async updateStatus({ commit }, payload) {
      try {
        const { firmId, ...statusUpdate } = payload;
        const response = await rest.post(`/firm/${firmId}/status`, statusUpdate);
        return response;
      } finally {
      }
    },
    async paginateFirmWithQuestionStat({ commit }, pagination = {}, clearStateBeforeRest = false) {
      try {
        commit("firmWithQuestionStatLoading", true);
        if (clearStateBeforeRest) {
          commit("firmWithQuestionStatPagination", undefined);
        }
        const response = await rest.post(`/firm/detailed`, { pagination });
        commit("firmWithQuestionStatPagination", response.data);
        return response;
      } finally {
        commit("firmWithQuestionStatLoading", false);
      }
    },
    async download({ commit }) {
      commit("isDownloading", true);
      try {
        const response = await rest.post("/firm/download");
        return response;
      } finally {
        commit("isDownloading", false);
      }
    },
    async checkOrganizationFirmLimit() {
      try {
        const response = await rest.get("/firm/check-limit");
        return response;
      } finally {
      }
    },
    async inviteAdmin({ }, { firm, invite }) {
      if (!firm?._id) {
        throw new Error("firm id missing");
      }
      const payload = JSON.parse(JSON.stringify(firm));
      payload.adminInvite = {
        name: invite.name,
        email: invite.email,
        phone: invite.phone,
      };
      if (payload.admin && payload.admin._id) {
        payload.admin = { _id: payload.admin._id };
      }
      return rest.put("/firm", { item: payload });
    },
  },
});
